import { combineReducers } from "@reduxjs/toolkit"

import accountReducer from "./slices/account"
import borrowReducer from "./slices/borrow"
import depositReducer from "./slices/deposit"
import depositActionReducer from "./slices/deposit-action"
import leaderboardReducer from "./slices/leaderboard"
import matsnetReducer from "./slices/matsnet"
import onboardingReducer from "./slices/onboarding"
import portalReducer from "./slices/portal"
import receiptTokenReducer from "./slices/receipt-token"
import referralsReducer from "./slices/referrals"
import storeReducer from "./slices/store"
import uiReducer from "./slices/ui"
import walletReducer from "./slices/wallet"

const mainReducer = combineReducers({
  account: accountReducer,
  deposit: depositReducer,
  leaderboard: leaderboardReducer,
  portal: portalReducer,
  referrals: referralsReducer,
  ui: uiReducer,
  wallet: walletReducer,
  depositAction: depositActionReducer,
  receiptToken: receiptTokenReducer,
  matsnet: matsnetReducer,
  borrow: borrowReducer,
  store: storeReducer,
  onboarding: onboardingReducer,
})

export type RootState = ReturnType<typeof mainReducer>

export default mainReducer
